
export function convertToLink(linkName){
	linkName = linkName.toLowerCase();
    linkName = linkName.replace(new RegExp("\\s", 'g'),"-");
    linkName = linkName.replace(new RegExp("[àáâãäå]", 'g'),"a");
    linkName = linkName.replace(new RegExp("[èéêë]", 'g'),"e");
    linkName = linkName.replace(new RegExp("[ìíîï]", 'g'),"i");
    linkName = linkName.replace(new RegExp("[òóôõöő]", 'g'),"o");
    linkName = linkName.replace(new RegExp("[ùúûüű]", 'g'),"u");

    return linkName;
}

export function getCurrentDate(){
	var today = new Date();
	var dd = String(today.getDate()).padStart(2, '0');
	var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
	var yyyy = today.getFullYear();

	return yyyy + '.' + mm + '.' + dd;
}


// WEBPACK FOOTER //
// ./src/functions.js